import React from 'react'
import {
  Box,
  Typography,
  Card,
  CardContent,
  Alert,
} from '@mui/material'

const DeptEvaluationPage: React.FC = () => {
  return (
    <Box>
      <Typography variant="h4" component="h1" gutterBottom>
        部門評価
      </Typography>
      
      <Card>
        <CardContent>
          <Alert severity="info">
            部門評価機能は実装中です。部門メンバーの評価リストと業績データ入力がここに表示されます。
          </Alert>
        </CardContent>
      </Card>
    </Box>
  )
}

export default DeptEvaluationPage